module.exports = __webpack_public_path__ + "static/media/dollarFlower.89f04ae5.svg";